import { Component, OnInit } from '@angular/core';
import {Page} from '../shared/page';
import {Match} from '../shared/match';
import {HomeService} from './home.service';
import {Chart} from './chart';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  page: Page = {
    title: 'Key Statistics',
    subtitle: ' - matching statistics for Music Point catalog'
  };
  match:  Match = {
    numberMatched: 0,
    lastMatch: 'Never',
    totalActiveRecords: 0,
    songsAddedOrModified: 0,
    chartData: null,
    percentMatched: 0
  };
  chart: Chart;

  constructor(private homeService: HomeService) { }

  ngOnInit() {
    this.initChart();
    this.homeService.getLastMatchDate().subscribe(res  => this.match.lastMatch = res.lastMatch);
    this.homeService.getTotalPlays().subscribe(res  => {
      // for(var i=0; i<=res.totalActiveRecords; i++) {
      //   this.match.totalActiveRecords++;
      //
      // }
      this.match.totalActiveRecords = res.totalActiveRecords;
      this.homeService.getNumberOfMatches().subscribe(result  => {
        this.match.numberMatched = result.numberMatched;
        this.match.percentMatched = result.numberMatched / this.match.totalActiveRecords;

        this.chart.data = [
          {
            'name': 'Matched',
            'value': this.match.numberMatched
          },
          {
            'name': 'Unmatched',
            'value': this.match.totalActiveRecords - this.match.numberMatched
          }
        ];


        // this.match.chartData.options = {
        //   responsive: true
        // };

        // this.match.chartData.data = [
        //   { data: [330, 600, 260, 700], label: 'Account A' },
        //   { data: [120, 455, 100, 340], label: 'Account B' },
        //   { data: [45, 67, 800, 500], label: 'Account C' }
        // ];

        // this.match.chartData.labels = ['Matched', 'Unmatched'];
        // this.match.chartData.percentColors = ['#DAF7A6', '#FF5733'];
        // this.match.chartData.data = [{ data: [this.match.percentMatched, 100-this.match.percentMatched] }];
      });
    });
    this.homeService.getModified().subscribe(res  => this.match.songsAddedOrModified = res.songsAddedOrModified);

  }

  initChart() {
    this.chart = new Chart();
    this.chart.size = [1200, 500];
    this.chart.colors = {
      domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    };
    this.chart.data = [
      {
        'name': 'Matched',
        'value': 0
      },
      {
        'name': 'Unmatched',
        'value': 0
      }
    ];
  }

  onSelect(event) {
    console.log(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts